import { useMemo } from 'react';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { FPS_24 } from '@/App/remotion/constants';
import { roundToNDecimalPlaces } from '@/libs/utils';

export default function useRemotionPlayerDuration() {
  const { clipData } = useClipsContext();
  const playerConfig = clipData.asset_metadata.player_config;

  const playerDuration = useMemo(() => {
    // Keeping this as Infinity to avoid division by zero
    return roundToNDecimalPlaces((playerConfig?.durationInFrames || Infinity) / FPS_24, 3);
  }, [playerConfig?.durationInFrames]);

  return playerDuration;
}
